import { actionCreator, asyncActionCreators } from '../../utils/actions';

export const login = asyncActionCreators('LOGIN');
export const logout = actionCreator('LOGOUT');
export const register = asyncActionCreators('REGISTER');
export const confirmRegister = asyncActionCreators('CONFIRM_REGISTER');

export const checkUserExist = asyncActionCreators('CHECK_USER_EXIST');
export const requestResetPassword = asyncActionCreators('REQUEST_RESET_PASSWORD');

export const userExists = actionCreator('USER_EXISTS');
export const userNotExists = actionCreator('USER_NOT_EXISTS');



// WEBPACK FOOTER //
// ./src/sagas/auth/actions.js